import * as XLSX from 'xlsx'

function Data() {
  return fetch('./Data.xlsx')
    .then((response) => {
      return response.arrayBuffer();
    })
    .then((file) => {
      const wb = XLSX.read(file, { type: 'array' });

      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];

      /* Convert array of arrays */
      return XLSX.utils.sheet_to_json(ws, { range: 1 }); /* range:1 set second line to header in table */
    });
}

export default Data